import './badge.scss';
import classNames from 'classnames';
import * as React from 'react';
import { BadgeIcon } from './BadgeIcon';
import { Wrapper } from './Wrapper';
export const Badge = ({ badge, size, layout, background, borderRadius, font, textStyle = {}, truncateTitle, hideDefaultIcon, onClick, onLoadIcon, className, }) => {
    const backgroundClass = background ? '' : 'no-background';
    const cursorClass = onClick ? 'pointer' : '';
    const wrapperClass = classNames('wrapper', size ? size : '', layout, backgroundClass, cursorClass, className);
    const showName = layout !== 'icon-only';
    const textClass = classNames('text', truncateTitle && 'truncated');
    const onBadgeClick = () => {
        if (onClick) {
            onClick(badge);
        }
    };
    return (React.createElement(Wrapper, { badge: badge, layout: layout },
        React.createElement("div", { "data-tooltip-id": badge.id, "data-tooltip-content": badge.title, onClick: onBadgeClick, className: wrapperClass, style: {
                ...(badge.backgroundColor
                    ? { backgroundColor: badge.backgroundColor }
                    : {}),
                ...(borderRadius ? { borderRadius: `${borderRadius}px` } : {}),
            } },
            React.createElement("div", { className: "inner" },
                React.createElement(BadgeIcon, { layout: layout, size: size, badgeIcon: badge.icon, hideDefaultIcon: hideDefaultIcon, onLoadIcon: onLoadIcon }),
                showName && (React.createElement("span", { className: textClass, style: {
                        ...(badge.textColor ? { color: badge.textColor } : {}),
                        ...(font ? { fontFamily: font } : {}),
                        ...textStyle,
                    } }, badge.title))))));
};
//# sourceMappingURL=Badge.js.map